export const PASSWORD_VALIDATE_REGEX = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

export function hasUppercase(value: string | null | undefined): boolean {
  return !!value && /[A-Z]/.test(value);
}

export function hasLowercase(value: string | null | undefined): boolean {
  return !!value && /[a-z]/.test(value);
}

export function hasDigit(value: string | null | undefined): boolean {
  return !!value && /\d/.test(value);
}

export function hasMinLength(
  value: string | null | undefined,
  length: number = 8,
): boolean {
  return !!value && value.length >= length;
}